import { ref } from 'vue-demi';

export const useSettingsCloseConfirm = () => {
  type Resolve = (result: boolean) => undefined;
  const isClosePopupOpen = ref(false);
  const callback = ref((() => {}) as Resolve);

  const onCloseConfirm = () => {
    isClosePopupOpen.value = false;
    callback.value(true);
  };

  const onCloseCancel = () => {
    isClosePopupOpen.value = false;
    callback.value(false);
  };

  const checkConfirmClose = async () => {
    isClosePopupOpen.value = true;
    return await new Promise<boolean>(resolve => {
      callback.value = resolve as Resolve;
    });
  };

  return {
    isClosePopupOpen,
    checkConfirmClose,
    onCloseConfirm,
    onCloseCancel,
  };
};
